import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';
import { Languages } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="glass border-cyber-blue text-cyber-blue hover:bg-cyber-blue/10 flex items-center gap-2"
    >
      <Languages className="w-4 h-4" />
      {i18n.language === 'de' ? 'EN' : 'DE'}
    </Button>
  );
};

export default LanguageSwitcher;